<template>
    <div class="slideInner" :data-index="index">
        <fade-transition>
            <video v-show="slide._loaded"
                   class="slider-video"
                   :poster="posterFallback(slide)"
                   preload="auto" muted autoplay playsinline loop
            >
                <source v-if="canAutoplay" :src="slide.url" type="video/mp4">
            </video>
        </fade-transition>

        <div v-if="slide" class="sliderVideoInfoWrapper">
            <div class="sliderVideoInfo__playBtnWrapper">
                <router-link :to="mediaDetailPath"
                             class="sliderVideoInfo__playBtn">
                    <media-player-play-icon/>
                </router-link>
            </div>

            <div class="sliderVideoInfoContent">
                <div class="sliderVideoInfo__editorNameWrapper">
                    <div class="sliderVideoInfo__editorName">
                        {{credits('editor')}}
                    </div>
                </div>

                <div class="sliderVideoInfo__clientNameWrapper">
                    <div class="sliderVideoInfo__clientName">
                        {{credits('brand')}}
                    </div>
                </div>

                <div class="sliderVideoInfo__videoNameWrapper">
                    <div class="sliderVideoInfo__videoName">
                        {{credits('title')}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import {mediaProps} from "../utils/shared";
    import MediaPlayer from "./MediaPlayer";

    export default {
        components: {MediaPlayer},
        props: ['slide', 'index', ],
        data() {
            return {}
        },
        computed: {
            ...mapGetters('ui', [
                'canAutoplay',
            ]),
            ...mapGetters('home', [
                'posterFallback',
            ]),
            media() {
                return mediaProps.get(this.slide)
            },
            mediaDetailPath() {
                return {path: this.slide.link}
            }
        },
        mounted() {
        },
        methods: {
            credits(section) {
                let credits = this.slide.credits

                return credits[section] && credits[section].name
                    ? credits[section].name
                    : ''
            },
            onTap(target) {
                // tap in region
                if (target.closest('.sliderVideoInfoWrapper')) {
                    this.$router.push(this.mediaDetailPath)
                }

            },
        }
    }
</script>

<style>
    .sliderVideoInfoWrapper {
        touch-action: pan-y;
    }

    .sliderVideoInfo__playBtn svg {
        max-width: 100%;
    }

    .device-mobile .sliderVideoInfo__playBtnWrapper {
        display: none;
    }
</style>
